import { RAMQInfo } from "@/Common/Models/RAMQ/RAMQInfo";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";

class RAMQResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.RAMQ_CheckSubscription, this.CheckSubscription);
    }

    private CheckSubscription(response: ServerEvent): void {
        window.setTimeout(() => {
            var ramqInfo = new RAMQInfo().FromResponse(response);
            var operation = new LocalEvent(LocalOperations.Misc.UpdateRAMQInfoInPatient);
            operation.AddItem("Contact_id", response.Data.PatientContactId);
            operation.AddItem("RAMQInfo", ramqInfo);
            RAMQEventDispatcher.dispatch(operation);
        }, 100);
    }
}

export { RAMQResponseHandler };
